module.exports = __webpack_public_path__ + "static/rose-1-ef2e5a377da4d7fe316383b039aeb33f.png";